// `video.shots`: a video's hard cuts, as its shots (spec G14-ad-swap), the worker's own ffmpeg.
// A source ad's remake reads them before planning its parts; a template's run starts it, and no
// screen lists it.
import { VideoShotsQuote, VideoShotsRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"video.shots"> = {
  type: "video.shots",
  label: "Video shots",
  source: "form",
  pair: "video.shots",
  fields: () => ({}),
  request: VideoShotsRequest,
  quote: VideoShotsQuote,
};
